export default {
  STONE: require("../assets/images/theme/default/rakeback/level/STONE.png"),
  IRON: require("../assets/images/theme/default/rakeback/level/IRON.png"),
  SILVER: require("../assets/images/theme/default/rakeback/level/SILVER.png"),
  GOLD: require("../assets/images/theme/default/rakeback/level/GOLD.png"),
  PLATINUM: require("../assets/images/theme/default/rakeback/level/PLATINUM.png"),
  DIAMOND: require("../assets/images/theme/default/rakeback/level/DIAMOND.png"),
  BLUE_ACE: require("../assets/images/theme/default/rakeback/level/ACE_BLUE.png"),
} as any;
